import React, { useState } from 'react';
import { ReportModal } from './ReportModal';
import './MediaCard.css';
import { useAppContext } from '../AppContext'; // Re-add useAppContext import

const MediaCard = ({ whisper, onClick, t }) => {
    const { LucideIcons } = useAppContext(); // Destructure LucideIcons from useAppContext
    const [showReportModal, setShowReportModal] = useState(false);

    const views = whisper.views || 0;
    const likes = whisper.likesCount || 0;
    const dislikes = whisper.dislikesCount || 0;
    const amplifies = whisper.echoesInvested || 0;
    const imageUrl = whisper.mediaUrls && whisper.mediaUrls.length > 0 ? whisper.mediaUrls[0] : whisper.mediaUrl;

    if (!imageUrl) {
        return null;
    }

    const handleReportClick = (e) => {
        e.stopPropagation(); // Prevent card click event from firing
        setShowReportModal(true);
    };

    return (
        <>
            {showReportModal && (
                <ReportModal
                    contentId={whisper.id}
                    contentType="moment"
                    authorId={whisper.authorId}
                    onClose={() => setShowReportModal(false)}
                    t={t}
                />
            )}
            <div className="media-card" onClick={onClick}>
                <img src={imageUrl} alt={whisper.content || 'User media'} className="media-card-image" />
                <div className="media-card-overlay">
                    <p className="media-card-content">{whisper.content}</p>
                    <div className="media-card-stats">
                        <div className="media-card-stat-item" title="Views">
                            <LucideIcons.Eye size={16} />
                            <span>{views}</span>
                        </div>
                        <div className="media-card-stat-item" title="Likes">
                            <LucideIcons.ThumbsUp size={16} />
                            <span>{likes}</span>
                        </div>
                        <div className="media-card-stat-item" title="Dislikes">
                            <LucideIcons.ThumbsDown size={16} />
                            <span>{dislikes}</span>
                        </div>
                        <div className="media-card-stat-item" title="Amplifies">
                            <LucideIcons.Zap size={16} />
                            <span>{amplifies}</span>
                        </div>
                        <button onClick={handleReportClick} className="flex items-center space-x-1 text-gray-400 hover:text-white transition-colors">
                            <LucideIcons.Flag size={16} />
                            <span>{t('mediaCard.report')}</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MediaCard;
